var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "service-picker-mobile-container" },
    [
      _c("smooth-picker", {
        attrs: { data: _vm.setServiceOptions, change: _vm.handleServiceChange }
      }),
      _vm._v(" "),
      _c("BaseButton", {
        attrs: { title: "Choose", classNames: ["button--modifier"] },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.handleChoose($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fa9c160", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fa9c160","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseServicePickerMobile.vue
// module id = null
// module chunks = 